import React from 'react';
import { ProfilePage } from './ProfilePage';

// Page Favoris = alias pour ProfilePage avec watchlist
export const FavorisPage = ProfilePage;
